// export const BASEURL = 'https://getehr.synapstics.com/'
export const BASEURL = 'https://getehr.curegrid.co/'
export const AGORA_APP_ID = '99499b61fbef4cdd955aabd0bcd529fe'
export const headers = {
    'Authorization': 'a7143772a09f993125901ea752bfd4fcf4b31d29',
    'Content-Type': 'application/json'
  };